export default "<p>\r\n  sidebar-right works!\r\n</p>\r\n"